import styled from "styled-components";

export const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: -webkit-fill-available;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
`;
